import React from 'react';

const PanelContext = React.createContext({
  stackSize: 0,
  nextPanel: () => {}
});

export default PanelContext;
